<template>
  <div class="smart-logo inline-block" v-html="logoSource" />
</template>

<script>
// @flow
import LogoRed from "assets/logo-red.svg";
import LogoWhite from "assets/logo-white.svg";
import LogoSmart from "assets/logo-smart2.svg";

export default {
  name: "SmartLogo",
  props: {
    white: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    smart: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoSource() {
      if (this.white) {
        return LogoWhite;
      }
      if (this.red) {
        return LogoRed;
      }
      if (this.smart) {
        return LogoSmart;
      }
      return LogoWhite;
    },
  },
};
</script>

<style lang="scss">
.smart-logo {
  transform-origin: right;
  transform: scale(0.6);
}
</style>
